// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   
import './behaviors_app.js';
import { 
    getScore, getIcon, getColor, feedback_mapping 
} from './utility.js'
import { a11yStyles, disclosureButton, uniqueId, accessibleTextColor } from './a11y.js';
import { t, Localized } from './i18n.js';

export class IntrivityAttitudesApp extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            /* Was a styled <div>; now a real heading so the report has a
               navigable structure (WCAG 1.3.1, 2.4.6). Black on #808080 is
               5.3:1, which clears AA. */
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
            .section-header .disclosure {
                vertical-align: middle;
                margin-left: 8px;
                padding: 4px;
            }
        `];
    }

    static get properties() {
        return {
            domain: { type: Object },
            domain_prefix: { type: String },
            report: { type: Object },
            group_report: { type: Object },
            expanded: { type: Boolean },
            activated: { type: Boolean },
            printable: { type: Boolean }
        };
    }

    constructor() {
        super();
        this._panelId = uniqueId('attitudes');
        this.expanded = false;
        this.activated = false;
        this.getRawScore = this.getRawScore.bind(this);
        this.isAttitudesCompleted = this.isAttitudesCompleted.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    getRawScore(i) {
        return this.report[this.domain.code].attitudes[i].average;
    }
    
    getTeamScore(i) {
        let groups = [];
        if (this.group_report) {
            let max = 1;
            for (let key in this.group_report[this.domain.code].attitudes[i].responses) {
                if (this.group_report[this.domain.code].attitudes[i].responses.hasOwnProperty(key)) {
                    let group = {};
                    group.score = Number(key).toFixed(1);
                    group.size = this.group_report[this.domain.code].attitudes[i].responses[key].length; //console.log("GROUPSIZE:" + group.size);
                    if (max < group.size) max = group.size;
                    // weight should be 5 - 20 => 15*x/maxx + 4
                    group.weight = this.group_report[this.domain.code].attitudes[i].responses[key].length * 5;
                    groups.push(group);
                }
            }
            console.log("MAXSIZE: " + max);
            for (let i =0; i < groups.length; i++) {
                groups[i].max = max;
            }
            //let group = {};
            //group.score = this.group_report[this.domain.code].attitudes[i].average;
            //group.size = this.group_report.users.length;
            //group.weight = 5; //??
            //groups.push(group);
        }
        return groups;
    }
    
    isAttitudesCompleted() {
        return this.report[this.domain.code].attitudes.length > 0;
    }
    
    render() {
        return html`
        
            ${this.activated || (this.report && this.isAttitudesCompleted) ? html`
                
                <h2 class="section-header">
                    ${t('domainDetails.attitudes')}
                    ${this.printable ? html``: disclosureButton(this.expanded, t('domainDetails.attitudes'), this._panelId, () => { this.expanded = !this.expanded; })}
                </h2>
        
            ` : html`

                <h2 class="section-header" style="color: white; background-color: #767676;">
                    ${t('domainDetails.attitudes')} <span style="color: black;">${t('domainDetails.activate')}</span>
                </h2>
        
            `}
        
            ${this.expanded || this.printable ? html`
                <div id=${this._panelId} style="width: 100%;">
                    ${this.report[this.domain.code].attitudes.length > 0 ? html`
                    ${this.domain.attitudes.map((attitude, i) => 
                        html`
                        
                            <div style="display: grid; grid-template-columns: 1fr 1fr; width: 100%; background-color:  white; padding: 10px; padding-top: 15px; padding-left: 30px; padding-right: 30px;">
                                <div style="margin: 10px;">
                                    <div style="color: ${accessibleTextColor(this.domain.color)}; font-size: 1.6em; margin-bottom: 20px;">${attitude.name.toUpperCase()}</div>
                                    <div style="margin-bottom: 20px;">${attitude.definition}</div>      
                                    <div style="margin-bottom: 20px;">${t('domainDetails.sampleItem', { sample: attitude.sample })}</div>
                                </div>
                                <div style="margin: 10px; padding-right: 20px;">
                                     <div><intrivity-likert-report .size_max=${this.group_report.num} .right_text=${attitude.right_label} .left_text=${attitude.left_label} .you=${this.getRawScore(i)} .groups=${this.getTeamScore(i)} .color=${this.domain.color} .colorhue=${this.domain.colorhue} .colorsat=${this.domain.colorsat} .colorlight=${this.domain.colorlight + 30.0}></intrivity-likert-report></div>
                                     <div style="margin: 5%;">${attitude.meaning[feedback_mapping[getScore(this.getRawScore(i)) - 1]]}</div>
                                 </div>
                            </div>
                        `
                    )}
                    `: html`<div style="padding-left: 30px;">${t('domainDetails.noData')}</div>`}
                </div>    
            `: html``}
        `
    } 
 
}
if (!customElements.get('intrivity-attitudes')) customElements.define('intrivity-attitudes', IntrivityAttitudesApp);
